import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'
import { history, store } from './store'
import { Provider } from 'react-redux'
import Actions from './actions'
import LogRocket from 'logrocket'
import { isProduction } from './utils/envUtils'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import { HistoryRouter as Router } from 'redux-first-history/rr6'

// STYLES
import './styles/reset-css.css'
import './styles/theme.css'

// FONT ICON
import './resources/fonts/antidote-v1.0/style.css'

const privateFieldNames = ['password', 'token', 'ssn']
const { requestSanitizer, responseSanitizer } =
  LogrocketFuzzySanitizer.setup(privateFieldNames)

if (isProduction) {
  LogRocket.init('zvveep/enrollment-app', {
    network: {
      requestSanitizer,
      responseSanitizer
    }
  })
} else {
  LogRocket.init('zvveep/enrollment-app-qa', {
    network: {
      requestSanitizer,
      responseSanitizer
    }
  })
}

store.dispatch(Actions.createAction(Actions.APP_LAUNCHED))

const root = createRoot(document.getElementById('root'))

root.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
